var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isPhoneBool)?_c('v-list-item-action',{staticClass:"ma-0"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":"disabled","size":"13"}},'v-icon',attrs,false),on),[_vm._v("mdi-cursor-default-click")])]}}],null,false,2114153767)},[_c('span',[_vm._v(_vm._s(_vm.$t('double_clickable')))])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }